import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import Plus from '@alltrails/denali/icons/Plus';
import styles from './AddPhotoButton.module.scss';

type AddPhotoButtonProps = {
  isMobile?: boolean;
  handleClick: () => void;
};

const AddPhotoButton = ({ isMobile, handleClick }: AddPhotoButtonProps) => {
  return (
    <div className={styles.addPhotoButton}>
      <Button
        onClick={handleClick}
        text={<FormattedMessage defaultMessage="Add photo" />}
        variant="elevated"
        icon={{ Component: Plus }}
        size={isMobile ? 'sm' : 'md'}
      />
    </div>
  );
};

export default AddPhotoButton;
